import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  GetAllUsersDataType,
  GetDashboardDataParamsType,
  GetDashboardDataType,
  GetSingleUserDataType,
  GetUserLogDataDataType,
  GetUserLogDataParamsType,
  GetUserStatusType,
} from "../../../types/portal/user";

export const userApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query<GetAllUsersDataType, GetQueryArgsType<any>>({
      query: (queryArgs) => ({
        url: API_URL.getAllUsers,
        params: queryArgs.params,
      }),
      providesTags: ["GetUsers"],
    }),

    getSingleUser: builder.query<GetSingleUserDataType, string>({
      query: (id) => ({
        url: `${API_URL.getSingleUser}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetSingleUser", id }],
    }),

    createUser: builder.mutation({
      query: (data) => ({
        url: API_URL.createUser,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUsers"];

        return [];
      },
    }),
    updateSingleUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateSingleUser}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            "GetUser",
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),

    firstTimeLogin: builder.mutation({
      query: ({ email, data }) => ({
        url: `${API_URL.firstTimeLogin}/${email}`,
        method: "POST",
        // method: "PATCH",
        body: data,
      }),
    }),

    updateResetPassword: builder.mutation({
      query: (data) => ({
        url: API_URL.updateResetPassword,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUser", "GetUsers", "GetSingleUser"];

        return [];
      },
    }),

    updateOwnPassword: builder.mutation({
      query: (data) => ({
        url: API_URL.updateOwnPassword,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUser", "GetSingleUser"];

        return [];
      },
    }),

    getDashboardData: builder.query<
      GetDashboardDataType,
      GetQueryArgsType<GetDashboardDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardData,
        params: queryArgs.params,
      }),
      providesTags: ["GetDashboardData"],
    }),

    getUserLogData: builder.query<
      GetUserLogDataDataType,
      GetQueryArgsType<GetUserLogDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getUserLogData,
        params: queryArgs.params,
      }),
      providesTags: ["GetUserLogData"],
    }),
    updateUserStatus: builder.mutation({
      query: (data) => ({
        url: API_URL.updateUserStatus,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUserStatus", "GetSingleUser", "GetUsers"];

        return [];
      },
    }),
    getUserStatus: builder.query<GetUserStatusType, string>({
      query: (email) => ({
        url: `${API_URL.getUserStatus}/${email}`,
      }),
      providesTags: ["GetUserStatus"],
    }),

    createUserIfNotExist: builder.mutation({
      query: (data) => ({
        url: API_URL.createUserIfNotExist,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUsers"];
        return [];
      },
    }),
  }),
});

export const {
  useCreateUserMutation,
  useGetAllUsersQuery,
  useGetSingleUserQuery,
  useUpdateSingleUserMutation,
  useFirstTimeLoginMutation,
  useUpdateResetPasswordMutation,
  useUpdateOwnPasswordMutation,
  useGetDashboardDataQuery,
  useGetUserLogDataQuery,
  useGetUserStatusQuery,
  useUpdateUserStatusMutation,
  useCreateUserIfNotExistMutation,
} = userApi;
